export const VERSION = '4.11.1'; // x-release-please-version
//# sourceMappingURL=version.mjs.map